<template>
  <div class="desktop-info-card p-4 shadow-md">
    <div v-if="mydata.desktopInfoMessage == '404'">
    </div>

    <div v-else>
    <div class="flex flex-wrap gap-5 font-extrabold">
      
      <div class="flex gap-5">
      <div class="mb-5 p-5 flex flex-wrap w-1/3 text-white bg-primary rounded">
        <span class="block text-base mb-3 leading-loose">
                اطلاعات کلی
            </span>
          <vs-divider/>
          <span class="w-full my-1 text-right">OS: {{ mydata.desktop.image && mydata.desktop.image.title ? mydata.desktop.image.title : 'N/A' }}</span>
          <span class="w-full my-1 text-right" dir="ltr">Plan: {{ mydata.desktop.plan.plan_title }}</span>
          <span class="w-full my-1 text-right" dir="ltr">Online Cost: {{ mydata.desktop.plan.plan_online_price | money }}</span>
          <span class="w-full my-1 text-right" dir="ltr">Ofline Cost: {{ mydata.desktop.plan.plan_shutdown_price | money }}</span>
          <span class="w-full my-1 text-right">CPU: {{ mydata.desktop.vm_cpu }}</span>
          <span class="w-full my-1 text-right">RAM: {{ mydata.desktop.vm_ram }}</span>
          <span class="w-full my-1 text-right">Hard: {{ mydata.desktop.vm_storage }}</span>

          <!-- <span class="w-full my-1 text-right">UUID: {{ mydata.desktop.uuid }}</span> -->
          <!-- <span class="w-full my-1 text-right">Username: {{ mydata.desktop.vm_default_username }}</span> -->
          <!-- <span class="w-full my-1 text-right">Password: {{ mydata.desktop.vm_default_password }}</span> -->
          <!-- <span class="w-full my-1 text-right">VDI Panel URL: {{ mydata.desktop.vdi_panel_url }}</span> -->
          <!-- <span class="w-full my-1 text-right">VDI Panel Username: {{ mydata.desktop.vdi_panel_username }}</span> -->
          <!-- <span class="w-full my-1 text-right">VDI Panel Password: {{ mydata.desktop.vdi_panel_password }}</span> -->
          <!-- <span class="w-full my-1 text-right">Status: {{ mydata.desktop.vm_status_title }}</span> -->
          <vs-divider/>
          <span class="w-full my-1 text-right">Created At: {{ mydata.desktop.created_at }}</span>
          <span class="w-full my-1 text-right">Updated At: {{ mydata.desktop.updated_at }}</span>
          <!-- <span class="w-full my-1 text-right">Country: {{ mydata.desktop.country.country_name }}</span> -->
          <!-- <span class="w-full my-1 text-right">Datacenter: {{ mydata.desktop.datacenter.title }}</span> -->
          <!-- <span class="w-full my-1 text-right">Location: {{ mydata.desktop.location.title }}</span> -->
      </div>

      <div class="mb-5 p-5 flex flex-wrap w-1/3 text-white bg-primary rounded font-extrabold">
        <span>
          اطلاعات کاربر
        </span>
        <vs-divider/>
        <span class="w-full my-1 text-right">User ID: {{ mydata.desktop.user_info.id }}</span>
        <span class="w-full my-1 text-right">Name: {{ mydata.desktop.user_info.name }}</span>
        <span class="w-full my-1 text-right">Email: {{ mydata.desktop.user_info.email }}</span>
        <span class="w-full my-1 text-right">Mobile: {{ mydata.desktop.user_info.mobile }}</span>
        <span class="w-full my-1 text-right">Credit: {{ mydata.desktop.user_info.balance | money }}</span>
        <span class="w-full my-1 text-right">Point: {{ mydata.desktop.user_info.point_balance | money }}</span>
        <!-- User ID: 2383
        Name: مهرداد هوشمند
        Email: m.hooshmand@haiocloud.com
        Mobile: 1111111
        Credit: 0
        Point: 22,709,468 -->

        <!-- <span class="w-full my-1 text-right">User ID: {{ mydata.desktop.user_info.id }}</span> -->

        <vs-divider/>
      </div>

      <div class="mb-5 p-5 flex flex-wrap w-1/3 text-white bg-primary rounded font-extrabold">
        <div class="w-full flex justify-between text-base leading-loose">
          <span>
            <span v-if="mydata.desktop.vm_status_title == 'آنلاین'" class="bg-success p-2 rounded-full w-3 h-3 inline-block"></span>
            <span v-else class="bg-red-600 p-2 rounded-full w-3 h-3 inline-block"></span>
            {{ mydata.desktop.vm_status_title }}
          </span>
          <span>
            {{ mydata.desktop.vm_sequence_id }}
          </span>
        </div>
        <vs-divider/>
          <span class="w-full my-1 text-right">Location: {{ mydata.desktop.country.country_name_latin }}</span>
          <span class="w-full my-1 text-right" dir="ltr">Datacenter ID: {{ mydata.desktop.datacenter.id }} ({{ mydata.desktop.datacenter.datacenter_name }})</span>
          <span class="w-full my-1 text-right">{{ mydata.desktop.local_ip_address }}</span>
          <span class="w-full my-1 text-right">VDI ID: {{ mydata.desktop.id }}</span>
          <span class="w-full my-1 text-right">VDI name: {{ mydata.desktop.title }}</span>
          <span class="w-full my-1 text-right">{{ mydata.desktop.vdi_panel_username }}</span>
          <span class="w-full my-1 text-right">{{ mydata.desktop.vdi_panel_password }}</span>
        <vs-divider/>
      </div>
      
      
      <div class="w-1/3 mb-5 mx-2 p-5 rounded bg-primary text-right leading-loose font-extrabold" >
        <!-- Actions -->
        <div class="flex justify-between mb-3">
          <button class="w-full mx-2 px-4 py-2 bg-green-800 text-white rounded hover:bg-green-500" @click="confirmReboot">ریبوت</button>
          <button class="w-full mx-2 px-4 py-2 bg-orange-800 text-white rounded hover:bg-orange-500" @click="confirmShutdown">خاموش</button>
          <button class="w-full mx-2 px-4 py-2 bg-red-800 text-white rounded hover:bg-red-700" @click="confirmDelete">حذف</button>
        </div>
        <button class="w-full my-1 px-4 py-2 bg-yellow-800 text-white rounded hover:bg-yellow-500" @click="$emit('updateDesktop', mydata.desktop.id); fetchTasks()">تازه سازی اطلاعات</button>
        <button class="w-full my-1 px-4 py-2 bg-yellow-800 text-white rounded hover:bg-yellow-500" @click="fetchPlans">تغییر پلن</button>
        <div v-if="planOptions" class="text-left">
          <span class="text-white block mb-4">لطفا پلن جدید را انتخاب کنید:</span>
          <vs-select v-model="selectedPlan" class="w-full mb-4">
            <vs-select-item :key="plan.id" :value="plan" :text="plan.plan_title" v-for="plan in planList" />
          </vs-select>
          <vs-button @click="changePlan(mydata.desktop.id, selectedPlan.id)" class="px-5 py-2 w-full bg-success text-white rounded">تغییر پلن</vs-button>
        </div>

        <div v-if="loginLink !== ''" class="w-full flex my-3">
          <button class="px-4 py-2 w-full bg-blue-800 text-white rounded hover:bg-blue-600" @click="copyLoginLink">
            کپی لینک ورود
          </button>
          <a class="w-full" :href="loginLink" target="_blank">
            <button class="w-full px-4 py-2 bg-blue-800 text-white rounded hover:bg-blue-600">
              ورود به دسکتاپ
            </button>
          </a>
        </div>
        <button v-else class="px-4 w-full py-2 bg-green-800 text-white rounded hover:bg-green-600" @click="fetchLoginLink">درخواست لاگین</button>  
        
      </div>
    </div>

    </div>
    <button v-if="!fetchedTasks" class="px-4 py-2 bg-blue-800 text-white rounded hover:bg-blue-600" @click="fetchTasks">دریافت تسک ها</button>
    <table v-else class="min-w-full text-center">
          <thead class="text-xs text-grey text-center bg-primary">
            <tr class="border  border-white border-opacity-25 text-center">
              <th scope="col" class="border text-center border-white border-opacity-25 px-6 py-3">شناسه</th>
              <th scope="col" class="border border-white border-opacity-25 px-6 py-3">نوع رویداد</th>
              <th scope="col" class="border border-white border-opacity-25 px-6 py-3">وضعیت</th>
              <th scope="col" class="border border-white border-opacity-25 px-6 py-3">جزئیات</th>
              <th scope="col" class="border border-white border-opacity-25 px-6 py-3">زمان</th>
              <th scope="col" class="border border-white border-opacity-25 px-6 py-3">عملیات</th>
            </tr>
          </thead>
          <tbody class="">
            <tr class="border border-white border-opacity-25 text-center "  :key="task, index" v-for="(task, index) in taskslist" >

              <th scope="row" class="px-6 py-4 whitespace-nowrap text-center">{{ task.id }}</th>
              <td class="border border-white border-opacity-25 px-6 py-4 text-center">{{ task.method_name }}</td>
              <td class="border border-white border-opacity-25 px-6 py-4">{{ task.status }}</td>
              <td class="border border-white border-opacity-25 px-2 py-4 text-center">
              </td>
              <td v-if="task.details.prev_cpu" style="direction:ltr" class="border border-white border-opacity-25 px-2 py-4 text-center">
              </td>
              <td class="border border-white border-opacity-25 px-6 py-4 text-center">{{ task.created_at }}</td>
              <td class="border border-white border-opacity-25 px-6 py-4 text-center gap-4 flex justify-center">
                <span @click="reRunTask(task.id)" class="cursor-pointer">
                  <feather-icon  icon="RefreshCwIcon"  class="w-6 rotate" />
                </span>
                <span @click="cancelTask(task.id)" class="cursor-pointer">
                  <feather-icon icon="StopCircleIcon" class="w-6 rotate" />
                </span>

              </td>
            </tr>
          </tbody>
    </table>
    <vs-pagination class="mt-4 right-0 flex p-2" v-model="currenttasksPage" :total="last_page"></vs-pagination>

    </div>

  </div>


</template>

<script>
export default {
  props: {
    mydata: {}
  },
  data() {
    return {
      loginLink: '',
      currenttasksPage: 1,
      last_page: 1,
      taskslist: [],
      fetchedTasks: false,
      planList: [],
      selectedPlan: '',
      planOptions: false,
    };
  },
methods: {
    rebootDesktop() {
        this.$http.get(`/admin/cloud/desktop/${this.mydata.desktop.id}/reboot`)
        .then((res) => {
          this.$vs.notify({ text: res.data.message });
          this.$emit('updateDesktop', this.mydata.desktop.id);
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message });
        });
    },
    shutdownDesktop() {
        this.$http.get(`/admin/cloud/desktop/${this.mydata.desktop.id}/shutdown`)
        .then((res) => {
          this.$vs.notify({ text: res.data.message });
          this.$emit('updateDesktop', this.mydata.desktop.id);
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message });
        });
    },
    confirmReboot() {
      if (confirm("Are you sure you want to reboot this desktop?")) {
        this.rebootDesktop();
        this.fetchTasks();
      }
    },
    confirmShutdown() {
      if (confirm("Are you sure you want to shutdown this desktop?")) {
        this.shutdownDesktop();
        this.fetchTasks();
      }
    },
    confirmDelete() {
      if (confirm("Are you sure you want to delete this desktop?")) {
        this.deleteDesktop();
        this.fetchTasks();
      }
    },
    deleteDesktop() {
        this.$http.delete(`/admin/cloud/desktop/${this.mydata.desktop.id}`, { method: 'DELETE' })
        .then((res) => {
          this.$vs.notify({ text: res.data.message });
          this.$emit('updateDesktop', this.mydata.desktop.id);
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message });
        });
    },
    copyLoginLink() {
        navigator.clipboard.writeText(this.loginLink);
        this.$vs.notify({ text: 'Login link copied to clipboard' });
    },
    fetchLoginLink() {
        this.$http.get(`/admin/cloud/desktop/${this.mydata.desktop.id}/login`)
        .then((res) => {
          this.loginLink = res.data.params.vdi_url;
          this.$vs.notify({ text: res.data.message });
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message });
        });
    },
    fetchTasks() {
      this.$http.get(`/admin/cloud/desktop/${this.mydata.desktop.id}/tasks?page=${this.currenttasksPage}`)
      .then((res) => {
        this.taskslist = res.data.params.data;
        this.last_page = res.data.params.last_page;
        this.fetchedTasks = true;
      })
      .catch((err) => {
        this.$vs.notify({ text: err.response.data.message });
      });
    },
    fetchPlans() {
      this.$http.get(`/admin/cloud/desktop/plans?page=1&filter=&location=${this.mydata.desktop.location.id}`)
        .then((res) => {
          this.planList = res.data.params.data;
          this.planOptions = true;
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message });
        });
    },
    changePlan(desktopId, planId) {
      this.$http.put(`/admin/cloud/desktop/${desktopId}/plan`, { plan_id: planId })
        .then((res) => {
          this.$vs.notify({ text: res.data.message, color: 'success' });
          this.$emit('updateDesktop', desktopId);
          this.planOptions = false;
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message, color: 'danger' });
        });
    },
    reRunTask(id) {
      this.$http
        .post("/admin/cloud/tasks/rerun",{task_id: id})
        .then((res) => {
          this.$vs.notify({ text: res.data.message });
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message });
        });
        this.$forceUpdate();
        this.fetchTasks();
    },
    cancelTask(id) {
      this.$http
        .post("/admin/cloud/tasks/cancel",{task_id: id})
        .then((res) => {
          this.$vs.notify({ text: res.data.message });
        })
        .catch((err) => {
          this.$vs.notify({ text: err.response.data.message });
        });
      this.$forceUpdate();
      this.fetchTasks();
    },
},
mounted() {
    this.fetchTasks();
}
}
</script>

<style scoped>

</style>
